function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from "prop-types";
import React, { useMemo } from "react";
import classnames from "classnames";
import Base from "../Base/Base";
import PlaformContext from "./PlatformContext";
import "./Platform.css";
export default function Platform({
  children,
  onConsoleClose,
  openConsolePosition,
  openConsoleWidth,
  responsive,
  shade = "shade-1",
  ...rest
}) {
  const classes = classnames("ax-platform", `ax-platform--${shade}`, {
    "ax-platform--responsive": responsive,
    "ax-platform--console-open": openConsolePosition
  });
  const providerValue = useMemo(() => ({
    onConsoleClose,
    openConsolePosition,
    openConsoleWidth
  }), [onConsoleClose, openConsolePosition, openConsoleWidth]);
  return /*#__PURE__*/React.createElement(PlaformContext.Provider, {
    value: providerValue
  }, /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
    className: classes
  }), children, /*#__PURE__*/React.createElement("div", {
    className: "ax-platform__mask",
    onClick: () => onConsoleClose && onConsoleClose()
  })));
}